<template>
  <svg
    width="36"
    height="34"
    viewBox="0 0 36 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 11.7995L5.00133 12.4301C5.98937 12.5859 6.95634 12.0409 7.35749 11.1026C9.4241 6.262 14.0537 3.04291 19.2124 2.99976C19.299 2.99976 19.3864 2.99976 19.4739 2.99976C27.0832 3.08127 33.1215 9.43873 32.9981 17.2299C32.878 24.8557 26.8038 30.9998 19.3279 30.9998C11.8521 30.9998 5.65534 24.7318 5.65534 16.9998"
      stroke="#D3CAF1"
      stroke-width="4.75992"
      stroke-miterlimit="10"
    />
    <path
      d="M23.7231 17.8572L20.0631 25.3585C19.7626 25.975 18.8936 25.975 18.5931 25.3585L14.933 17.8572C14.8202 17.6252 14.8202 17.354 14.933 17.1229L18.5931 9.62156C18.8936 9.00505 19.7626 9.00505 20.0631 9.62156L23.7231 17.1229C23.8359 17.3549 23.8359 17.6261 23.7231 17.8572Z"
      stroke="#462170"
      stroke-width="1.24615"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.3281 18.8728C20.0827 18.8728 20.6943 18.2537 20.6943 17.49C20.6943 16.7263 20.0827 16.1072 19.3281 16.1072C18.5736 16.1072 17.9619 16.7263 17.9619 17.49C17.9619 18.2537 18.5736 18.8728 19.3281 18.8728Z"
      fill="#462170"
      stroke="#462170"
      stroke-width="1.24615"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.3612 2.35938C19.3612 2.35938 19.2105 4.18607 19.3612 5.25194"
      stroke="#462170"
      stroke-width="1.24615"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.2949 32.6213C19.2949 32.6213 19.4456 30.7946 19.2949 29.7288"
      stroke="#462170"
      stroke-width="1.24615"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.37915 17.4565C4.37915 17.4565 6.18392 17.6091 7.23701 17.4565"
      stroke="#462170"
      stroke-width="1.24615"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M34.2783 17.5236C34.2783 17.5236 32.4735 17.3711 31.4204 17.5236"
      stroke="#462170"
      stroke-width="1.24615"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
